import { deliveryStage } from '../../fields'
import { ShortcutArgs } from '../../types'
import { getDateString } from '../dates'
import { isField } from '../fields'
import { getFormattedFieldValue } from './utils'

export const getPregnancyValue = (path: string, shortcutArgs: ShortcutArgs): string | undefined => {
  // ex: payments.received.0
  const { assessment, plan } = shortcutArgs ?? {}
  const [, fieldPath] = path.split('.')
  // const { selectedCoverage } = assessment ?? {}
  // const firstVisitDate = selectedCoverage?.initialServiceDate
  const firstVisitDate = plan?.initialServiceDate
  if (!fieldPath) return undefined
  switch (fieldPath) {
    case 'firstVisit':
      return firstVisitDate ? getDateString(firstVisitDate, 'short') : undefined
    default: {
      const field = deliveryStage.children[fieldPath]
      if (field && isField(field)) {
        return getFormattedFieldValue(field, fieldPath, assessment?.mergedData?.delivery)
      }
      return undefined
    }
  }
}
